var _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.5 231.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m387.1,104.5h-6.5l-34-51.4v51.4h-6.8V40.4h6.5l34,51.2v-51.2h6.8v64.1Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m452.7,81.1c0,7.1-1.8,12.7-5.5,16.6-4.6,4.9-10.3,7.4-17.1,7.4s-11.9-2.2-16.4-6.7c-2.8-2.8-4.5-5.8-5.1-9.1-.6-3.3-.9-8.9-.9-16.8s.3-13.5.9-16.8c.6-3.3,2.3-6.4,5.1-9.1,4.4-4.4,9.9-6.7,16.4-6.7s11,1.8,15,5.3c4,3.5,6.5,8.1,7.4,13.9h-6.8c-.9-4.1-2.7-7.3-5.5-9.6s-6.1-3.5-10.1-3.5-8.1,1.5-11.1,4.6c-1.9,2-3.2,4.4-3.7,7.2-.5,2.8-.8,7.7-.8,14.7s.3,11.9.8,14.8c.5,2.8,1.8,5.2,3.7,7.2,2.9,3,6.6,4.5,11.1,4.5s9.1-1.8,12.1-5.5c2.4-2.9,3.6-6.8,3.6-11.6v-4.9h-15.8v-6h22.6v10.2Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m514.6,55.7c.6,3.3.9,8.9.9,16.8s-.3,13.5-.9,16.8c-.6,3.3-2.3,6.4-5.1,9.1-4.4,4.4-9.9,6.7-16.4,6.7s-11.9-2.2-16.4-6.7c-2.8-2.8-4.5-5.8-5.1-9.1-.6-3.3-.9-8.9-.9-16.8s.3-13.5.9-16.8c.6-3.3,2.3-6.4,5.1-9.1,4.4-4.4,9.9-6.7,16.4-6.7s11.9,2.2,16.4,6.7c2.8,2.8,4.5,5.8,5.1,9.1Zm-6.7,31.5c.5-2.8.8-7.7.8-14.7s-.3-11.9-.8-14.7c-.5-2.8-1.8-5.2-3.7-7.2-2.9-3.1-6.6-4.6-11.1-4.6s-8.1,1.5-11.1,4.6c-1.9,2-3.2,4.4-3.7,7.2-.5,2.8-.8,7.7-.8,14.7s.3,11.9.8,14.7c.5,2.8,1.8,5.2,3.7,7.2,2.9,3.1,6.6,4.6,11.1,4.6s8.1-1.5,11.1-4.6c1.9-2,3.2-4.4,3.7-7.2Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m378.4,194.5h-11.7v-28.6c0-2.9-.8-5-2.2-6.3-1.5-1.3-3.3-2-5.4-2s-3.9.7-5.4,2c-1.5,1.4-2.2,3.4-2.2,6.3v28.6h-11.7v-64.1h11.7v21.5c3.2-3.2,6.9-4.9,11.2-4.9s8.8,1.6,11.6,4.7c2.7,3.2,4.1,7.3,4.1,12.4v30.3Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m433.9,194.5h-11.4v-4.3c-3.1,3.2-7,4.9-11.7,4.9s-8.3-1.4-11.1-4.1c-3.2-3.2-4.8-7.6-4.8-13.3v-30h11.7v28.4c0,2.9.8,5.1,2.3,6.5,1.5,1.4,3.3,2.1,5.4,2.1s4-.7,5.5-2.1c1.5-1.4,2.3-3.5,2.3-6.5v-28.4h11.7v46.9Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m490.6,163.6c.1,1.8.2,4.3.2,7.4s0,5.6-.2,7.4c-.1,1.8-.6,4-1.3,6.5-.8,2.5-1.8,4.5-3.3,5.9-2.8,2.8-6.6,4.2-11.4,4.2s-8.8-1.6-11.7-4.9v4.4h-11.3v-64.1h11.7v21.3c2.8-3.1,6.6-4.7,11.3-4.7s8.6,1.4,11.4,4.2c1.4,1.4,2.5,3.4,3.3,5.9.8,2.5,1.2,4.6,1.3,6.4Zm-11.5,7.4c0-4.4-.5-7.8-1.5-10-1-2.2-3.1-3.4-6.4-3.4s-5.4,1.1-6.4,3.4c-1,2.2-1.5,5.6-1.5,10s0,4,.3,5.4c.2,1.4.5,2.8,1,4.1.5,1.3,1.3,2.3,2.4,3,1.1.7,2.5,1,4.2,1s3.1-.3,4.2-1c1.1-.7,1.9-1.6,2.4-3,.5-1.3.9-2.7,1-4.1.2-1.4.3-3.2.3-5.4Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m192.7,10.9l14,2.1,59,104.7-59,104.7-14.9,2.2,60.4-106.9L192.7,10.9Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.7 224.5 132.8 231.8 73.9 224.4 13.6 117.6 72.9 10.9 132.8 0 192.7 10.9 252.1 117.6 191.7 224.5",
    fill: "#fed210",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.6 117.6 73.9 224.4 59 222.3 0 117.6 59 12.9 72.9 10.9 13.6 117.6",
    fill: "#231f20",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m102.6,148h-12.6v-27.1h-21.9v27.1h-12.6v-64.7h12.6v26.4h21.9v-26.4h12.6v64.7Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m159.8,125.8c0,6.7-2.3,12.2-6.8,16.4-4.5,4.2-10.2,6.3-17,6.3s-12.5-2.1-17-6.3c-4.5-4.2-6.8-9.7-6.8-16.4v-42.5h12.6v42.1c0,3.7,1,6.6,3,8.7,2,2.1,4.7,3.2,8.2,3.2s6.2-1.1,8.2-3.2c2-2.1,3-5,3-8.7v-42.1h12.5v42.5Z",
    fill: "#231f20",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m216.2,129.4c0,5.9-1.8,10.5-5.5,13.7-3.6,3.3-8.4,4.9-14.4,4.9h-27.1v-64.7h26c6.2,0,11.1,1.6,14.7,4.9,3.5,3.3,5.3,7.7,5.3,13.3s-.8,6.1-2.5,8.4c-1.7,2.3-3.5,4-5.5,5,5.9,2.8,8.9,7.6,8.9,14.5Zm-15.7-21.9c1.5-1.4,2.2-3.2,2.2-5.4s-.7-4-2.2-5.4c-1.5-1.4-3.5-2-6.2-2h-12.4v14.9h12.4c2.7,0,4.7-.7,6.2-2Zm.9,27c1.5-1.5,2.2-3.4,2.2-5.7s-.7-4.2-2.2-5.7c-1.5-1.5-3.5-2.2-6.3-2.2h-13.2v15.9h13.2c2.7,0,4.8-.8,6.3-2.3Z",
    fill: "#231f20",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0db1be08598775740a2c54e91d83a40b.svg";
export { ForwardRef as ReactComponent };